import React, { useEffect } from 'react'
import { useVsgSdk } from 'alelo-logic/contexts/vsgSdkContext'

import { Container } from './styles'

const ForgotPassword = props => {
  document.title = 'Minha Veloe | Esqueci senha'
  const vsgSdk = useVsgSdk()

  useEffect(() => {
    const forgotPasswordComponent = vsgSdk.renderizarEsqueciSenha({
      background: '/images/wronguser.png',
      showCnpj: false,
      loginType: 'cpf',
      title: 'Relaxa! Isso acontece com todo mundo.',
      subtitle:
        'E você pode contar conosco para te ajudar. Você precisa informar os seus dados de acesso abaixo:',
      validationLinkMessage: 'Caso não tenha recebido, clique no botão “Reenviar e-mail”.'
    })

    forgotPasswordComponent.on('cancelar', () => {
      props.history.push('/conta/login')
    })
  }, [vsgSdk])

  return <Container id="vsg-esqueci-senha" data-testid="vsg-esqueci-senha" />
}

export default ForgotPassword
